import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  products: [],
  productList: [],
  searchProduct: [],
  searchStore: "",
  productById: {},
  currentPage: 1,
  limit: 10,
  totalItems: 0,
  totalPages: 0,
  frequentProduct: [],
  storeProducts: [],
  drugList: [],
  status: "idle",
  error: null,
  cancel: false,
  customProducts: [],
  tagsList: [],
  manufacturersList: [],
  nrxDrugNames: [],
  drugManagement: {
    drugs: [],
    currentPage: 1,
    limit: 10,
    totalItems: 0,
    totalPages: 0,
    stats: {
      totalDrugs: 0,
      totalAssigned: 0,
      totalUnassigned: 0,
    },
    loading: false,
  },
};

const ProductSlice = createSlice({
  name: "product",
  initialState,
  reducers: {
    createProduct: (state, action) => {
      state.products.push(action.payload);
    },
    updateProduct: (state, action) => {
      const { productId, updatedData } = action.payload;
      const existingProduct = state?.products?.find(
        (product) => product?.IID === productId
      );
      if (existingProduct) {
        Object.assign(existingProduct, updatedData);
      }

      if (state.searchProduct && state.searchProduct.length > 0) {
        const searchProduct = state.searchProduct.find(
          (product) => product?.IID === productId
        );
        if (searchProduct) {
          Object.assign(searchProduct, updatedData);
        }
      }
    },
    setProducts: (state, action) => {
      const { products, currentPage, totalItems, totalPages } = action.payload;
      state.products = products;
      state.currentPage = currentPage;
      state.totalItems = totalItems;
      state.totalPages = totalPages;
      state.status = "succeeded";
    },
    setSearchProducts: (state, action) => {
      state.searchProduct = action.payload;
      state.status = "succeeded";
    },
    setSearchStore: (state, action) => {
      state.searchStore = action.payload;
      state.status = "succeeded";
    },
    deleteProduct: (state, action) => {
      try {
        state.searchProduct = state?.searchProduct?.filter(
          (product) => product?.id !== action.payload
        );
        state.products =
          state?.products?.length > 0
            ? state?.products?.filter(
                (product) => product?.id !== action.payload
              )
            : "";
      } catch (error) {
        console.error("Error in deleteProduct reducer:", error);
      }

      return;
    },
    createFrequentProduct: (state, action) => {
      state.frequentProduct.push(action.payload);
    },
    setFrequentProducts: (state, action) => {
      state.frequentProduct = action.payload;
      state.status = "succeeded";
    },
    setDrugList: (state, action) => {
      state.drugList = action.payload?.drugs;
      state.status = "succeeded";
    },
    setSearchDrugs: (state, action) => {
      // if (action.payload?.drugs) {
      //   const existingIds = new Set(state.drugList.map((item) => item.id));
      //   const filteredDrugs = action.payload?.drugs?.filter(
      //     (drug) => !existingIds.has(drug.id)
      //   );

      //   state.drugList = [...state.drugList, ...filteredDrugs];
      // } else {
      //   state.drugList = [...state.drugList, action.payload];
      // }
      state.drugList = action.payload;
      state.status = "succeeded";
    },
    deleteFrequentProduct: (state, action) => {
      try {
        if (state.frequentProduct && state.frequentProduct.length > 0) {
          state.frequentProduct = state.frequentProduct.filter((product) => {
            if (product.IID) {
              return product.IID !== action.payload;
            } else {
              return product?.product?.IID !== action.payload;
            }
          });
        }
      } catch (error) {
        console.error("Error in deleteFrequentProduct reducer:", error);
      }
    },
    deleteDrugs: (state, action) => {
      try {
        state.drugList = state?.drugList?.filter(
          (drug) => drug?.id !== action.payload
        );
      } catch (error) {
        console.error("Error in deleteProduct reducer:", error);
      }

      return;
    },
    setStoreProducts: (state, action) => {
      state.storeProducts = action.payload;
      state.productList = action.payload;
      state.status = "succeeded";
    },
    setSearchStoreProducts: (state, action) => {
      state.productList = action.payload;
      state.status = "succeeded";
    },
    setCancel: (state) => {
      state.cancel = true;
    },
    setLoading: (state, action) => {
      state.status = "loading";
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },
    setAdminProduct: (state, action) => {
      state.products = action.payload;
      state.loading = action.payload;
    },
    setCustomProducts: (state, action) => {
      state.customProducts = action.payload;
      state.status = "succeeded";
    },
    setTagsList: (state, action) => {
      state.tagsList = action.payload;
      state.status = "succeeded";
    },
    setDrugManagementData: (state, action) => {
      if (!state.drugManagement) {
        state.drugManagement = {
          drugs: [],
          currentPage: 1,
          limit: 10,
          totalItems: 0,
          totalPages: 0,
          stats: { totalDrugs: 0, totalAssigned: 0, totalUnassigned: 0 },
          loading: false,
        };
      }
      const { drugs, currentPage, limit, totalItems, totalPages, stats } = action.payload || {};
      state.drugManagement.drugs = drugs || [];
      state.drugManagement.currentPage = currentPage || 1;
      state.drugManagement.limit = limit || 10;
      state.drugManagement.totalItems = totalItems || 0;
      state.drugManagement.totalPages = totalPages || 0;
      if (stats) {
        state.drugManagement.stats = stats;
      }
      state.drugManagement.loading = false;
    },
    setDrugManagementLoading: (state, action) => {
      if (!state.drugManagement) {
        state.drugManagement = {
          drugs: [],
          currentPage: 1,
          limit: 10,
          totalItems: 0,
          totalPages: 0,
          stats: { totalDrugs: 0, totalAssigned: 0, totalUnassigned: 0 },
          loading: false,
        };
      }
      state.drugManagement.loading = action.payload;
    },
    setNRxDrugNames: (state, action) => {
      state.nrxDrugNames = action.payload || [];
    },
    setManufacturersList: (state, action) => {
      state.manufacturersList = action.payload || [];
    },
    addManufacturer: (state, action) => {
      if (action.payload) {
        const exists = state.manufacturersList?.some(
          (m) => m?.name?.toLowerCase() === action.payload?.name?.toLowerCase()
        );
        if (!exists) {
          state.manufacturersList = [...(state.manufacturersList || []), action.payload].sort((a, b) =>
            (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" })
          );
        }
      }
    },
    updateManufacturerInList: (state, action) => {
      const { id, name, oldName } = action.payload;
      if (state.manufacturersList) {
        state.manufacturersList = state.manufacturersList.map((m) =>
          m.id === id ? { ...m, name } : m
        ).sort((a, b) =>
          (a.name || "").localeCompare(b.name || "", undefined, { sensitivity: "base" })
        );
      }
      if (oldName && state.products) {
        state.products.forEach((p) => {
          if (p.manufacturer?.toLowerCase() === oldName.toLowerCase()) {
            p.manufacturer = name;
          }
        });
      }
    },
    removeManufacturerFromList: (state, action) => {
      const id = action.payload;
      if (state.manufacturersList) {
        state.manufacturersList = state.manufacturersList.filter((m) => m.id !== id);
      }
    },
  },
});

export const {
  createProduct,
  setSearchStoreProducts,
  setProducts,
  setSearchProducts,
  setSearchStore,
  setFrequentProducts,
  updateProduct,
  deleteProduct,
  createFrequentProduct,
  deleteFrequentProduct,
  setStoreProducts,
  deleteDrugs,
  setDrugList,
  setLoading,
  setSearchDrugs,
  setAdminProduct,
  setCustomProducts,
  setTagsList,
  setManufacturersList,
  addManufacturer,
  updateManufacturerInList,
  removeManufacturerFromList,
  setDrugManagementData,
  setDrugManagementLoading,
  setNRxDrugNames,
  setError,
  setCancel,
} = ProductSlice.actions;

export default ProductSlice.reducer;
